$yuf_number $mol_number
	String $yuf_number_string
		blur_event? <=> blur_event? null
		type <= type
		value? <=> value_string?
		hint <= hint
		- allow <= allow_enriched <= allow \0123456789
		enabled <= string_enabled
		submit? <=> submit?

$yuf_number_string $mol_string
	event *
		^
		blur? <=> blur_event? null
